import request from '../utils/request.js'

export default {
  // 流程库列表
  queryBuildInTemplate: data => {
    return request({
      data,
      url: '/generatorApi/queryBuildInTemplate',
      method: 'get'
    })
  },
  getRouter: data => {
    return request({
      data,
      url: '/generatorApi/getRouter',
      method: 'get'
    })
  },
  insertTemplate: data => {
    return request({
      data,
      url: '/generatorApi/insertTemplate',
      method: 'post'
    })
  }
}
